// timer.actions.ts
import { createAction } from '@ngrx/store';

export const startTimer = createAction('[Timer] Start Timer');
export const updateRemainingTime = createAction('[Timer] Update Remaining Time');
export const finishTimer = createAction('[Timer] Finish Timer');
